<div class="rsr-alert" [class]="variant()" [attr.role]="priority() === 'assertive' ? 'alert' : 'status'" [attr.aria-live]="priority()">
  @if ($icon()) {
    <mat-icon>{{$icon()}}</mat-icon>
  }
  <div class="alert__content">
    <ng-content></ng-content>
  </div>
</div>

